/* SEYUN Foundation PDP + LP: offer selector, real free-sponge cart line, sticky CTA. Isolated: only acts on pages that render [data-sfd-offer]. */
(() => {
  if (window.__seyunFd) return;
  window.__seyunFd = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  let busy = false;

  const scopeOf = el => el.closest('[data-sfd-scope], .product__info-container') || document;

  function applySelection(offer) {
    const scope = scopeOf(offer);
    const radio = $('input[type=radio]:checked', offer);
    if (!radio) return;
    $$('[data-sfd-id]', scope).forEach(i => { i.value = radio.value; });
    $$('[data-sfd-price]', scope).forEach(p => {
      const u = $('[data-sfd-unit]', p), c = $('[data-sfd-compare]', p), b = $('[data-sfd-badge]', p);
      if (u) u.textContent = radio.dataset.unit;
      if (c) { c.textContent = radio.dataset.compare || ''; c.hidden = !radio.dataset.compare; }
      if (b) { b.textContent = radio.dataset.badge || ''; b.hidden = !radio.dataset.badge; }
    });
    const sp = $('[data-sfd-stick-price]');
    if (sp) sp.textContent = radio.dataset.sticky || (radio.dataset.unit + ' /ea' + (radio.dataset.compare ? '  (was ' + radio.dataset.compare + ')' : ''));
    if (radio.dataset.ship) $$('[data-sfd-ship-text]').forEach(n => { n.textContent = radio.dataset.ship; });
  }

  function initOffers() {
    $$('[data-sfd-offer]').forEach(offer => {
      if (offer.dataset.ready) return;
      offer.dataset.ready = '1';
      offer.addEventListener('change', () => applySelection(offer));
      applySelection(offer);
    });
  }

  async function post(path, body) {
    const r = await fetch(root + path, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(body) });
    let j = {};
    try { j = await r.json(); } catch (e) {}
    if (!r.ok) throw new Error(j.description || j.message || 'Cart error');
    return j;
  }

  function notifyCart() {
    window.dispatchEvent(new CustomEvent('moonbundle-cart-updated', { detail: { caller: 'seyun-fd' } }));
    document.dispatchEvent(new CustomEvent('sfd:cart-updated'));
  }

  async function addToCart(form) {
    const scope = scopeOf(form);
    const offer = $('[data-sfd-offer]', scope) || $('[data-sfd-offer]');
    const radio = offer && $('input[type=radio]:checked', offer);
    const id = Number($('[data-sfd-id]', form).value);
    const qty = Math.max(1, Number(radio && radio.dataset.qty) || 1); // a pack = one variant x quantity
    const items = [];
    const giftIds = offer ? String(offer.dataset.giftVariants || offer.dataset.giftVariant || '').split(',').map(x => x.trim()).filter(Boolean) : [];
    const giftTag = (offer && offer.dataset.giftTag) || 'foundation-offer';
    if (radio && radio.dataset.gift === '1') giftIds.slice().reverse().forEach(g => items.push({ id: Number(g), quantity: 1, properties: { _free_gift: giftTag } }));
    items.push({ id, quantity: qty }); // added last so Shopify lists the bottles first, gifts below

    const btn = $('[data-sfd-atc]', form), err = $('[data-sfd-error]', scope);
    if (err) err.hidden = true;
    btn.setAttribute('aria-busy', 'true');
    busy = true;
    try {
      await post('cart/add.js', { items });
      notifyCart();
      await openDrawer();
    } catch (e) {
      if (err) { err.textContent = e.message; err.hidden = false; }
    } finally { busy = false; btn.removeAttribute('aria-busy'); }
  }

  async function openDrawer() {
    // Moon Bundles drawer (global app embed) listens to its own events; fall back to the cart page.
    await new Promise(r => setTimeout(r, 450));
    const drawer = $('#moonbundle-cart-drawer');
    if (drawer && drawer.classList.contains('open')) return;
    const trigger = $('a[href$="/cart"][id*="cart-icon"], #cart-icon-bubble, .header__icon--cart, [data-moonbundle-cart-trigger]');
    if (trigger) { trigger.click(); await new Promise(r => setTimeout(r, 500)); }
    const d = $('#moonbundle-cart-drawer');
    if (!(d && d.classList.contains('open')) && !$('cart-drawer.active, cart-drawer[open]')) window.location.assign(root + 'cart');
  }

  /* Keep the free sponge line in step with the 2-bottle offer lines (same page only). */
  async function readCart() {
    for (let i = 0; i < 4; i++) {
      try {
        const r = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (r.ok) return await r.json();
      } catch (e) {}
      await new Promise(r => setTimeout(r, 1200));
    }
    return null;
  }
  async function reconcile() {
    return; // gift lines are owned by the global sync (seyun-fd-sync.js, loaded by theme.liquid): 1 gift per pair of bottles
    const offer = $('[data-sfd-offer]');
    if (!offer || busy) return;
    const giftId = offer.dataset.giftVariant;
    if (!giftId) return;
    const packIds = $$('input[data-gift="1"]', offer).map(i => String(i.value));
    busy = true;
    try {
      const cart = await readCart();
      if (!cart) return;
      const pack = cart.items.filter(i => packIds.includes(String(i.variant_id))).reduce((s, i) => s + i.quantity, 0);
      const gifts = cart.items.filter(i => String(i.variant_id) === String(giftId));
      const have = gifts.reduce((s, i) => s + i.quantity, 0);
      if (have === pack) return;
      if (!gifts.length) {
        await post('cart/add.js', { items: [{ id: Number(giftId), quantity: pack, properties: { _free_gift: 'foundation-offer' } }] });
      } else {
        await post('cart/change.js', { id: gifts[0].key, quantity: pack });
        for (const g of gifts.slice(1)) await post('cart/change.js', { id: g.key, quantity: 0 });
      }
      notifyCart();
    } catch (e) { /* silent: checkout still works */ }
    finally { busy = false; }
  }
  let timer;
  const schedule = () => { clearTimeout(timer); timer = setTimeout(reconcile, 350); };

  function lockGiftRow() {
    const offer = $('[data-sfd-offer]');
    if (!offer || !offer.dataset.giftVariant || $('#sfd-gift-lock')) return;
    const s = document.createElement('style');
    s.id = 'sfd-gift-lock';
    const sel = '.moonbundle-cart-item[data-item-key^="' + offer.dataset.giftVariant + ':"]';
    s.textContent = sel + ' .moonbundle-cart-item-quantity-container,' + sel + ' .moonbundle-cart-item-remove-container{display:none!important}';
    document.head.appendChild(s);
  }

  if (!window.__sfdFetchPatched) {
    window.__sfdFetchPatched = true;
    const orig = window.fetch;
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const p = orig.apply(this, arguments);
      if (!busy && /\/cart\/(change|update|add)(\.js)?(\?|$)/.test(url) && !/moonbundle_ignore/.test(url)) p.then(schedule, () => {});
      return p;
    };
  }
  window.addEventListener('moonbundle-cart-updated', e => { if (!(e.detail && e.detail.caller === 'seyun-fd')) schedule(); });

  document.addEventListener('submit', e => {
    const form = e.target.closest && e.target.closest('.sfd-form');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addToCart(form);
  }, true);

  document.addEventListener('click', e => {
    const jump = e.target.closest('[data-sfd-jump]');
    if (jump) {
      const t = $('#sfd-buy') || $('[data-sfd-offer]');
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
    const go = e.target.closest('[data-sfd-stick-go]');
    if (go) {
      const f = $('.sfd-form');
      if (f) f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  });

  function initSticky() {
    const bar = $('[data-sfd-stick]') || $('[data-sfd-sticky]');
    const atc = $('[data-sfd-atc]');
    if (!bar || !atc || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    new IntersectionObserver(es => { bar.hidden = es[0].isIntersecting || atc.getBoundingClientRect().top > 0; }, { threshold: 0 }).observe(atc);
  }

  function announce() {
    const offer = $('[data-sfd-offer]');
    if (!offer) return;
    const txt = offer.dataset.announce || 'HALLOWEEN SALE · 2 FOUNDATIONS FOR $29 + FREE MAKEUP SPONGE · 90-DAY MONEY-BACK GUARANTEE';
    $$('.sy-announcement-desktop,.sy-announcement-mobile').forEach(n => { n.textContent = txt; });
  }
  function init() { initOffers(); initSticky(); lockGiftRow(); announce(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
